import React from 'react';
import { ShieldCheckIcon, WrenchIcon, ScanSearchIcon, DrillIcon, FrameIcon, HammerIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const tomos = [{
  n: '01',
  icon: ShieldCheckIcon,
  title: 'Mentalidad, Seguridad y Primeros Pasos',
  text: 'Perdé el miedo, entendé qué tareas podés hacer vos y cuáles requieren un profesional. Aprendé las normas básicas de seguridad antes de empezar.'
}, {
  n: '02',
  icon: WrenchIcon,
  title: 'Herramientas Básicas que Toda Casa Necesita',
  text: 'Qué herramientas comprar, cuáles son esenciales y cómo usarlas sin gastar de más. Tu primer kit de bricolaje bien armado.'
}, {
  n: '03',
  icon: ScanSearchIcon,
  title: 'Conocé Tus Paredes Antes de Perforar',
  text: 'Cómo identificar el tipo de pared, qué broca y tarugo usar en cada caso y cómo evitar cables o tuberías ocultas.'
}, {
  n: '04',
  icon: DrillIcon,
  title: 'Cómo Usar el Taladro Desde Cero',
  text: 'Aprendé a sostenerlo, colocar la broca, hacer el primer agujero y perforar recto sin nervios ni errores.'
}, {
  n: '05',
  icon: FrameIcon,
  title: 'Colgar Repisas, Cuadros, Espejos y Cortinas',
  text: 'El tomo más práctico. Instrucciones paso a paso para instalar los elementos más comunes del hogar de forma segura y prolija.',
  highlight: true
}, {
  n: '06',
  icon: HammerIcon,
  title: 'Arreglos Básicos y Proyectos de Mejora del Hogar',
  text: 'Puertas que rozan, cajones flojos, ganchos, manijas, agujeros en la pared y proyectos simples para transformar espacios.'
}];
export function Tomos() {
  return <section id="contenido" aria-labelledby="tomos-titulo" className="w-full border-y-2 border-ink bg-sand" data-id="element-174" data-mp="68uewjoqcayc">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-175" data-mp="232o19wmyvjwn">
        <Reveal data-id="element-176" data-mp="27zxp57upjnid">
          <SectionLabel data-id="element-177" data-mp="281iiwv9772f6">Contenido completo</SectionLabel>
          <h2 id="tomos-titulo" className="mt-4 font-display text-3xl font-bold leading-tight sm:text-[2.6rem]" data-id="element-178" data-mp="1zzrnoh7v5o1k">
            Los 6 tomos de Manos a la Casa
          </h2>
          <p className="mt-4 max-w-2xl text-lg text-graphite" data-id="element-179" data-mp="29xxlonqjua15">
            Todo lo que necesitás saber, organizado de forma progresiva y sin
            complicaciones.
          </p>
        </Reveal>

        <ol className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-180" data-mp="2iym03jjuucek">
          {tomos.map(({
          n,
          icon: Icon,
          title,
          text,
          highlight
        }, i) => <Reveal key={n} delay={i * 0.06} data-id="element-181" data-mp="2evz89in6orhd" data-mpi={i}>
              <li className={`group relative flex h-full flex-col rounded-2xl border-2 border-ink p-6 transition-transform duration-200 hover:-translate-y-1 ${highlight ? 'bg-ink text-cream' : 'bg-cream'}`} data-id="element-182" data-mp="2ev7mezje284a">
                <div className="flex items-center justify-between" data-id="element-183" data-mp="32n4pa14v1pt9">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-xl border-2 ${highlight ? 'border-cream/25 bg-clay text-cream' : 'border-ink/10 bg-clay/10 text-clay'}`} data-id="element-184" data-mp="2xoba849xdqqz">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-185" data-mp="37am5kz5p5e4m" />
                  </span>
                  <span className={`font-display text-3xl font-bold ${highlight ? 'text-cream/25' : 'text-ink/15'}`} data-id="element-186" data-mp="3c8xen7o63kls">
                    {n}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-xl font-bold leading-snug" data-id="element-187" data-mp="2ol62c42mn7ki">
                  <span className={`mr-2 text-[11px] font-semibold uppercase tracking-[0.18em] ${highlight ? 'text-clay' : 'text-clay'}`} data-id="element-188" data-mp="2tjheilge9u5w">
                    Tomo {n}
                  </span>
                  <br data-id="element-189" data-mp="2jnnwimjwp8gq" />
                  {title}
                </h3>
                <p className={`mt-3 text-[15px] leading-relaxed ${highlight ? 'text-cream/75' : 'text-graphite'}`} data-id="element-190" data-mp="3mvxlkly9dkxn">
                  {text}
                </p>
                {highlight && <span className="mt-5 inline-flex w-fit items-center rounded-full bg-clay px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-cream" data-id="element-191" data-mp="388cj8u97jpqs">
                    El más práctico
                  </span>}
              </li>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}